import "./App.css";
import Home from "./Components/Home";
import Work from "./Components/Work";

function HomePage() {
  return (
    <div className="App">
      <Home />
      <Work />   
    </div>
  );
}

export default HomePage;
